//Quick View
var quantity=1;
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
	  
    quickView();
  });
});

validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

function quickView() {
// Quickview and Wishlist loading fixed
  $(document).off('click', '.quick-view').on('click', '.quick-view', function (e) {
    e.preventDefault();

    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
// Quickview and Wishlist loading fixed

    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.media;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle+'?variant='+product.variants[0].id;

    //  var v_inv = v.inventory_management;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        var imgalts = image.alt;
        var image_alt = '';
        if(imgalts != null){
          image_alt = imgalts.replace(title,"");
          image_alt = image_alt.replace(/\s+/g, '').toLowerCase();
          image_alt = image_alt.replace("-","");
        }
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image.src + '" alt="' + image_alt + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image.src + '"  alt="' + image_alt + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div style="display:none" class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
        
        // Color swatched hack
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection2-' + opt.toLowerCase() + '"><div class="option min_block">' + opt + '<span id="color_name" class="color_name_c">'+option.values[0]+'</span></div>');
        $(option.values).each(function (i, value) {
          var select_option = '';
          if(i == 0){ select_option = "checked='checked'";}
          var swatch_img_name = value;
          swatch_img_name = swatch_img_name.toLowerCase();
          swatch_img_name = swatch_img_name.replace(" ", "-");
          swatch_img_name = 'https://cdn.shopify.com/s/files/1/0426/0619/8947/t/10/assets/'+swatch_img_name+'.png';
          $('.option-selection2-color').append('<div class="product-single__swatch__item"><input type="radio" '+select_option+' class="product-single__swatch__input u-hidden-visually" id="' + value + '" name="option_radio" value="' + value + '" /><label for="' + value + '" class="product-single__swatch__label"><span class="product-single__swatch__label__graphic" style="background-color: '+value+' ;background-image:url('+swatch_img_name+');"></span></label></div>');
        });   
        
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-add-to-cart .option_c_price').val(price);
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });
    
    $(document).on("click", ".product-single__swatch__item", function () {
      	var value = $(this).find('input[type=radio]').val();
        if(value != ''){
          $('input[type=radio]').attr('checked', false);
          $(this).find('input[type=radio]').attr('checked', true);
          $('.option-0.option.color').val(value).change();
          $(".color_name_c").text(value);
        }
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
                
        // MKT added image selection hack
        var selectedOptions_new = selectedOptions.toLowerCase();
        var image_index = $('img[alt="'+selectedOptions_new+'"]').parent().attr('data-slick-index');
        console.log("image_index: "+image_index);
        if(image_index != undefined){
          $('.qv-product-images').slick("goTo", image_index);
        }
        // MKT added image selection hack
        
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $('.qv-product-price').text('$' + price);
            $('.qv-add-to-cart .option_c_price').val(price);
            $('.qv-product-original-price').text('$' + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 800,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          //qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: quantity,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function (response) {
              gtag_report_conversion('',response);
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a class="js-cart-trigger js-no-transition" href="/cart">Click here to view your cart.</a>');
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
		  
		  
		  // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

       qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
		quantity=qty;
      });
    }
		  
		  
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
    $('.fancybox-skin .fancybox-close').append('<i class="icon icon--close" aria-hidden="true"></i>');
  });
  $(document).on("click", "#quick-view .js-cart-trigger", function(e) {
    $('a.fancybox-item.fancybox-close').trigger('click');
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});
